import React from 'react'
import DOMPurify from 'dompurify'
import { Box, Typography } from '@material-ui/core'
import { User as UserIcon } from 'react-feather'
import { isEmpty } from 'lodash'

import { MessageAttachment, MessageLinkedDocumentTemplate } from './components'
import { JoditEditor } from 'components'

import useStyles from './styles'
import helpers from 'helpers'
import constants from 'constants/index'

const TicketMessage = ({ message }) => {
  const classes = useStyles()

  const messageSanitizer = DOMPurify.sanitize(message?.content, {
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
  })

  const messageClass = (organization) => {
    if (organization) return classes.responsibleHeader

    return classes.requesterHeader
  }

  const messageType =
    message?.author?.organization ||
    (message?.author?.name === constants.tickets.MESSAGE_SYSTEM_AUTHOR &&
      'Automático') ||
    'Solicitante'

  return (
    <Box>
      <Box className={classes.requesterBoxContainer}>
        <Box className={messageClass(message?.author?.organization)}>
          <UserIcon className={classes.userIconBox} />
          <Box display="flex" alignItems="center">
            {!message?.author?.organization && (
              <Typography>{`${message?.author?.name} |`}</Typography>
            )}
            <Typography>
              &nbsp;
              {`${messageType} | `}
              {message?.author?.profile ? `${message?.author?.profile} | ` : ''}
              {helpers.formatters.date(message?.createdAt)} às&nbsp;
              {helpers.formatters.hours(message?.createdAt)}
            </Typography>
          </Box>
        </Box>

        <Box p={2}>
          {/* Embed (ex.: vídeo) só na resposta do suporte; mensagem do solicitante não renderiza iframe. */}
          <JoditEditor.Preview
            allowIframe={!!message?.author?.organization}
            content={messageSanitizer}
          />
        </Box>

        {message?.attachments?.length > 0 && (
          <Box pb={2} pl={1} gap={3}>
            {message?.attachments?.map((attachment) => (
              <MessageAttachment key={attachment.url} attachment={attachment} />
            ))}
          </Box>
        )}

        {!isEmpty(message?.linkedDocumentTemplates) && (
          <Box display="flex" flexWrap="wrap" pb={2} pl={1} gridGap={16}>
            {message.linkedDocumentTemplates.map((linkedDocumentTemplate) => (
              <MessageLinkedDocumentTemplate
                key={linkedDocumentTemplate.id}
                documentTemplate={linkedDocumentTemplate.documentTemplate}
              />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default TicketMessage
